import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import "./emsReportMangementTable.scss"

interface columnDataType {
  title: string;
  dataIndex: string;
}

interface EmsRptMgmtTblPropsType{
  data:any;
  regCode:string;
}

export const EmsReportManagementTable = ({ data,regCode }: EmsRptMgmtTblPropsType ) => {
  const { t } = useTranslation("reportsmanagement");
  const columnsFor5067: ColumnsType<columnDataType> = [
    {
      title: t("reportsManagement.patient"),
      dataIndex: "patient_name",
      width:180,
      align:"center"
    },
    {
      title: t("reportsManagement.requestedTime"),
      dataIndex: "requested_time",
      width:250,
      align:"center"
    },
    {
      title: t("reportsManagement.acceptedTime"),
      dataIndex: "accepted_time",
      width:250,
      align:"center"
    },
    {
      title: t("reportsManagement.firstRespondedTimeMinutes"),
      dataIndex: "first_responded_time",
      width:200,
      align:"center"
    },
    {
      title: t("reportsManagement.completedTime"),
      dataIndex: "completed_time",
      width:250,
      align:"center"
    },
    {
      title: t("reportsManagement.cancelledTime"),
      dataIndex: "cancelled_time",
      width:250,
      align:"center"
    },
    {
      title: t("reportsManagement.timerStartTime"),
      dataIndex: "timer_start_time",
      width:250,
      align:"center"
    },
    {
      title: t("reportsManagement.timerEndTime"),
      dataIndex: "timer_end_time",
      width:250,
      align:"center"
    },
    {
      title: t("reportsManagement.timeLapseMinutes"),
      dataIndex: "time_lapse",
      width:150,
      align:"center"
    },
    {
      title: t("reportsManagement.gender"),
      dataIndex: "gender",
      align:"center"
    },
    {
      title: t("reportsManagement.acceptedEmergencyUser"),
      dataIndex: "accepted_emergency_user",
      width:250,
      align:"center"
    },
    {
      title: t("reportsManagement.rejectedEmergencyUser"),
      dataIndex: "rejected_emergency_user",
      width:250,
      align:"center"
    },
    {
      title: t("reportsManagement.site"),
      dataIndex: "site",
      width:300,
      align:"center"
    },
    {
      title: t("reportsManagement.caseType"),
      dataIndex: "case_type",
      width:250,
      align:"center"
    },
  ];

  const columnsForemo1: ColumnsType<columnDataType> =[
    {
      title: t("reportsManagement.patient"),
      dataIndex: "patient_name",
      width:180,
      align:"center"
    },
    {
      title: t("reportsManagement.gender"),
      dataIndex: "gender",
      width:50,
      align:"center"
    },
    {
      title: t("reportsManagement.caseType"),
      dataIndex: "case_type",
      width:300,
      align:"center"
    },
  ]
    
  // 'auto' && 3000 for scroll x
  return (
    <div className="ems-rpt-mgmt-tbl-container">
      <Table
        columns={(regCode==="5067" || regCode === "0010") ? columnsFor5067 : columnsForemo1}
        scroll={{
          x:(regCode==="5067" || regCode === "0010") ? 3000 : 'auto',
        }}
        rowClassName={(_record, index) =>
          index % 2 === 0 ? "table-row-light " : "table-row-dark"
        }
        dataSource={data}
      />
    </div>
  );
  
};
